// extracted by mini-css-extract-plugin
export default {"Group":"carousel_Group__jrjec","ArrowLeft":"carousel_ArrowLeft__AwWkk","ArrowRight":"carousel_ArrowRight__vl9L-","post":"carousel_post__idn7H"};